<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:description" slot-scope="row">
                                <div v-if="checkIsJson(row.item.description)">
                                    <json-viewer
                                        :value="row.item.description | isJson"
                                        :expand-depth="0"
                                        sort>
                                    </json-viewer>
                                </div>
                                <div v-else v-html="row.item.description"></div>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import JsonViewer from 'vue-json-viewer';

    export default {
        name: 'audit-trail',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['audit_trail_user_info']));
            return {
                tableConfig:{
                    name: 'account-audit-trail-user-info',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport:false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                },
                tableItems: [],
                modals:{
                    detail: {
                        open: false,
                        loading: false,
                        data: null,
                    }
                },
                
            }
        },
        components: {JsonViewer},
        created () {},
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            }
        },
        methods:{
            //
            /*-- Table callback --------*/
            async getTableData(callback) {
                this.tableItems = [];
                this.tableConfig.total =0;
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("AuditTrailController/getAuditTrailUserInfo", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the audit trail user info", "danger");
                        reject();
                    })
            },
            exportItems(tableRequest) {
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                request.limit = -1;
                this.$store.dispatch( 'AuditTrailController/exportAuditTrailUserInfo', request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AuditTrailUserInfo.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
            /*---------------*/
            checkIsJson(item){
                if(!item) return false;
                try {
                    JSON.parse(item);
                } catch (e) {
                    return false;
                }
                return true;
            },
        }
    }
</script>
